module.exports = __webpack_public_path__ + "static/img/md.5f734d92.svg";